import React from 'react';
import PropTypes from 'prop-types';
import { RefreshWrapper } from './styles';
import IconFont from '../../../../components/shared/IconFont';

const RefreshButton = ({
  //label, color, size, weight,
  marginLeft,
}) => (
  <RefreshWrapper onClick={() => window.location.reload(false)}>
    <IconFont
      id="isLiveArrow"
      className="icon-matchcenter-refresh isLiveArrow"
      color="selectedColor"
      font={30}
      weight="bold"
      marginLeft={marginLeft}
      withCursor
      opacity="0"
    />
  </RefreshWrapper>
);

RefreshButton.propTypes = {
  //label: PropTypes.string,
  //color: PropTypes.string,
  //size: PropTypes.number,
  //weight: PropTypes.string,
  marginLeft: PropTypes.number,
};

export default RefreshButton;
